import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, Button, TextField, Typography, Container } from '@mui/material';
import { useToast } from '../context/ToastContext';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { showCorrect, showError } = useToast();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await login(form.username, form.password);
    if (success) {

      navigate('/profile');
      showCorrect('Login successful');
    } else {
      setError('Invalid credentials');
      showError('Invalid credentials');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 10 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Box
            component="img"
            src="/logotipo-uanataca-2.png"
            alt="Billing logo"
            sx={{ width: '100%', maxWidth: 220, height: 'auto' }}
          />
        </Box>
        <Typography variant="h5" gutterBottom>Login</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth margin="normal"
            // label="Username"
            placeholder='Username'
            value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
          />
          <TextField
            fullWidth margin="normal"
            // label="Password"
            placeholder='Password'
            type="password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
          {error && <Typography color="error">{error}</Typography>}
          <Button variant="contained" fullWidth sx={{ mt: 2 }} type="submit">Login</Button>
        </form>
      </Box>
    </Container>
  );
};

export default Login;
